export default "__VITE_ASSET__Bl5Qg70H__"